<template>
    <div class="timeline-item-navbar">
        <div class="animated-background-navbar">
            <div class="background-masker-navbar masker-top" :style="styles"></div>
            <div class="background-masker-items after-logo" :style="styles"></div>
            <div class="background-masker-items after-logo1" :style="styles"></div>
            <div class="background-masker-items after-logo2" :style="styles"></div>
            <div class="background-masker-items after-logo3" :style="styles"></div>
            <div class="background-masker-items after-logo4" :style="styles"></div>
            <div class="background-masker-items after-logo5" :style="styles"></div>
            <div class="background-masker-items right" :style="styles"></div>
            <div class="background-masker-items right1" :style="styles"></div>
            <div class="background-masker-items right2" :style="styles"></div>
            <div class="background-masker-items right3" :style="styles"></div>
            <div class="background-masker-navbar masker-bottom" :style="styles"></div>
        </div>
    </div>
</template>

<script>
import '@/styles/general/timeline-navbar.scss';

export default {
    name: 'TimelineNavbar',
    watch : {
        menuColor: {
            handler(v) {
                this.background = v;
            },
            immediate: true
        }
    },
    computed: {
        styles() {
            return {'background': this.background};
        }
    },
    props: {
        menuColor: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            background: '',
        }
    }
}
</script>
